module.exports = __webpack_public_path__ + "static/media/image.b5a8a62b.svg";